import AuthService from '../login/auth.service'
import axios from 'axios'
import { dimo } from "../../components/generico/utils/UrlAPI";

class dimoService {
    /**
   * Ahorro a la vista Socios
   * @param {*} canal 
   */
  async vincularSocioDimo(canal) {
    var data = JSON.stringify({
        idClienteEF: AuthService.getSocio().numeroSocio,
        ciCliente: Number(AuthService.getCISocio()),
        canal: canal

    });
    const config = {
      method: "post",
      url: dimo + "dimo/vincularSocio",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken()
        
      },
      data: data,
    };
    //console.log("valores:", options)
    return await axios(config)

  };
}

export default new dimoService();